import { useParams } from "react-router"
import { useRecoilState, useRecoilValue } from "recoil"
import closeButton from 'src/assets/images/closeButton.png'

import useAPI from "src/hooks/useAPI"
import useWindowDimensions from "src/hooks/useWindowDimensions"
import { MvmoTermsState, MvnoCheckValue, RecoilStateList, uiData } from "src/recoil/common"
import { MVNOPopupWrap, ModalBox, ModalWrap, PopupLayer, TermsCheckBox } from "src/styles/styledcomponent/component/common"
import { CustomBtn } from "src/styles/styledcomponent/views/join/JoinSubmit"
import { PramsKeys } from "src/types/type"

const MvnoModal = (props: any) => {
  const { pcode } = useParams<PramsKeys>()
  const CertApi = useAPI('requestSendCertNumber')
  const { width } = useWindowDimensions()
  const { submit } = props

    const { TelType, PhoneNum } = useRecoilValue(RecoilStateList)
    const [mvnoCheckValue,setMvnoCheckValue] = useRecoilState(MvnoCheckValue)
    const mvnoTermsData = useRecoilValue(MvmoTermsState)
    const { layoutsConfirm: { submitBtn } } = useRecoilValue(uiData)

    const certInput = document.getElementById('certInput')
    
    const { mutateAsync: getSendOtp } = CertApi.useSetMutation({
      Telecom: TelType,
      PNumber: PhoneNum,
      Pcode: pcode,
    })

    const acceptKTTerms = (e: React.ChangeEvent<HTMLInputElement>) => {
      setMvnoCheckValue(e.target.checked)
    }
    const modalClose = () => {
      submit.toggle() //toggle
      setMvnoCheckValue(false)
    }
    const checkTermTrue = () => {
      if (!mvnoCheckValue){
        if (window.confirm('서비스 이용을 위해 약관 동의가 필요합니다.\n모두 동의하시겠습니까?')){
          submit.toggle()
          setMvnoCheckValue(true)
          submit.cert(getSendOtp)
        }
      } else {
        submit.toggle()
        submit.cert(getSendOtp)
      }
      if (certInput) {
        setTimeout(() => {
          certInput.focus()
        }, 1000)
      }
    }
    return (
      submit.isOpen && ( 
        <ModalWrap toggle={submit.isOpen} zIndex={9990} width={`${width}px`} >
          <ModalBox onClick={(e: any) => e.stopPropagation()}>
            <PopupLayer>
              <MVNOPopupWrap className="popup_contents">
                <img src={closeButton} className="close-btn" alt="" onClick={modalClose} />
                <div className="top">
                  <h4 className="description">
                    KT MVNO(알뜰폰) 추가
                    <br />
                    약관 동의가 필요합니다.
                  </h4>
                  <h4 className="title">아래 약관 확인 후 동의해주세요.</h4>
                </div>
                <div className="terms-wrap">
                  <div className="check-wrap">
                    <input type="checkbox" id="terms-check"
                      onChange={acceptKTTerms}
                    />
                    <TermsCheckBox htmlFor="terms-check" isChecked={mvnoCheckValue}>
                      <p dangerouslySetInnerHTML={{ __html: decodeURIComponent(escape(atob(mvnoTermsData?.TermsTitle))), }} />
                      <i className="icon" />
                    </TermsCheckBox>
                  </div>
                  <div className="terms-contents-wrap">
                  <p className="terms-contents" dangerouslySetInnerHTML={{ __html: decodeURIComponent(escape(atob(mvnoTermsData?.Terms))), }} />
                  </div>
                </div>
                <CustomBtn
                  id="common_btn"
                  backgroundColor={submitBtn.backgroundColor}
                  borderRadius={"5px"}
                  width={width > 1200 ? "356px" : "328px"}
                  height={"44px"}
                  lineHeight="0px"
                  fontSize={"14px"}
                  onClick={checkTermTrue}
                >
                  <span>동의 및 인증번호 받기</span>
                </CustomBtn>
              </MVNOPopupWrap>
            </PopupLayer>
          </ModalBox>
        </ModalWrap>
      )
    )
}

export default MvnoModal